import { sessionStore } from './sessionStore'

export function useAdminView(): boolean {
  return sessionStore((state) => state.session?.role === 'admin' && !state.participantPreview)
}
